import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("确认");

import { computed, ref, watch } from 'vue';
import { getSupplierTreeInfo } from '@/request';
import { get } from 'lodash-es';
export default {
  name: 'SetExtensionScopeModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    defaultChecked: {
      type: Array,
      default: () => []
    },
    isSee: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const treeData = ref([]);
    const treeRef = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });

    function confirm() {
      visible.value = false;

      if (!props.isSee) {
        emit('success', treeRef.value.getCheckedNodes());
      }
    }

    const treeProps = ref({
      label: 'text',
      children: 'children'
    });
    watch(() => props.isSee, newVal => {
      if (newVal) {
        treeProps.value.disabled = 'id';
      }
    });
    getSupplierTreeInfo().then(data => {
      if (data !== null && data !== void 0 && data.length) {
        treeData.value = data;

        if (data.length === 1) {
          let list = [data[0]];
          let children = get(data, '[0].children', []);
          children.forEach(item => {
            list.push(item);
            let itemChildren = get(item, 'children', []);
            itemChildren.forEach(subItem => list.push(subItem));
          });
          emit('success', list, data.length);
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_tree = _resolveComponent("el-tree");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "推广范围设置",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        "destroy-on-close": "",
        width: "600px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          height: "500px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tree, {
            "default-checked-keys": __props.defaultChecked,
            data: treeData.value,
            "node-key": "id",
            ref_key: "treeRef",
            ref: treeRef,
            props: treeProps.value,
            "show-checkbox": ""
          }, null, 8, ["default-checked-keys", "data", "props"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};